import React from 'react'
import Home from '../src/pages/Home'

function App() {
  return (
    <Home></Home>
  )
}

export default App